import { mount } from 'svelte'
import * as Sentry from '@sentry/svelte'
import { registerFeatureFlags } from './stores/feature-flags'
import './assets/styles/fonts.css'
import './assets/styles/reset.css'
import './assets/styles/theme.css'
import './assets/styles/app.css'
import './assets/styles/buttons.scss'
import App from './App.svelte'

const { VITE_SENTRY_TRACES_SAMPLE_RATE, VITE_SENTRY_DSN, VITE_SENTRY_ENVIRONMENT_NAME, VITE_API_URL } = import.meta.env

const tracesSampleRate = Number(VITE_SENTRY_TRACES_SAMPLE_RATE) || 0.3

Sentry.init({
  dsn: VITE_SENTRY_DSN,
  sendDefaultPii: true,
  environment: VITE_SENTRY_ENVIRONMENT_NAME || 'production',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate,
  tracePropagationTargets: [VITE_API_URL],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
})

registerFeatureFlags()

const app = mount(App, {
  target: document.getElementById('app')!,
})

export default app
